var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-app',[_c('ion-vue-router'),(_vm.shouldShowTabs)?_c('Tabs'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }